import { getTextStyle } from "cms/theme/helpers";
import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2.5rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 5rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 7.5rem 0;
  }
`;

export const Content = Styled.div`
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  
  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const Branding = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  button {
    width: 100%;
  }

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    button {
      width: auto;
    }
  }
`;

export const BrandingInfo = Styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  padding-right: calc(3.5rem + 0.75rem);
`;

export const Links = Styled.div`
  border-top: 1px solid ${(props) =>
    props.theme.mode === "light"
      ? props.theme.colors.neutrals.gray200
      : props.theme.colors.neutrals.gray700};
  border-bottom: 1px solid ${(props) =>
    props.theme.mode === "light"
      ? props.theme.colors.neutrals.gray200
      : props.theme.colors.neutrals.gray700};

  padding: 2rem 0;
  margin: 2rem 0;
`;

export const Columns = Styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem 1.25rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    gap: 2.5rem 1.5rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    gap: 1.5rem 1.5rem;
  }
`;

export const Column = Styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: calc(100% / 2 - 1.25rem);

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex-basis: calc(100% / 3 - 1.5rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    flex: 1;
  }

  p {
    margin: 1.5rem 0 1rem 0;

    &:first-child {
      margin: 0 0 1rem 0;
    }
  }
`;

export const List = Styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Item = Styled.li`
`;

export const Link = Styled.a`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  ${(props) => getTextStyle(props.theme, "B4")};
  color: ${(props) => props.theme.colors.tokens.text.textDefault};
  transition: 300ms;
  text-decoration: none;

  &:hover, &:focus, &:active {
    color: ${(props) => props.theme.colors.tokens.text.textActivated};
  }
`;

export const Copyright = Styled.div`
  ${(props) => getTextStyle(props.theme, "B4")};
  color: ${(props) => props.theme.colors.tokens.text.textDefault};
  text-align: center;
`;
